@for (config of configs; track config) {
  @if (!config.customFormElement) {
    <div class="form--controls" [libGridCell]="config.grid">
      <form-control
        (linkClick)="linkClicked.emit({ config: config, event: $event })"
        (iconClick)="iconClicked.emit({ config: config, event: $event })"
        (selected)="selected.emit({ config: config, event: $event })"
        (inputChanged)="inputChanged.emit({ config: config, event: $event })"
        [direction]="direction"
        [config]="config"
        [group]="form"
        [control]="form.controls[config.prop]"
      >
      </form-control>
    </div>
  } @else {
    <div [libGridCell]="config.grid" [formGroup]="form">
      @switch (config.type) {
        @case ('formGroupArray') {
          <form-group-array [formControlName]="config.prop" [config]="config">
          </form-group-array>
        }
        @case ('optionalDate') {
          <optional-date
            [direction]="direction"
            [config]="config"
            [group]="form"
          >
          </optional-date>
        }
        @case ('conditionalToggle') {
          <conditional-toggle
            [formControlName]="config.prop"
            [parentForm]="form"
            [config]="config"
          >
          </conditional-toggle>
        }
        @default {
          <custom-form-element
            (formCreated)="handleFormCreated($event, config)"
            [direction]="direction"
            [config]="config"
            [form]="form"
            [prefillVal]="prefillVal"
          >
          </custom-form-element>
        }
      }
    </div>
  }
  <ng-template #customFormElement>
    <div [libGridCell]="config.grid" [formGroup]="form">
      @switch (config.type) {
        @case ('formGroupArray') {
          <form-group-array [formControlName]="config.prop" [config]="config">
          </form-group-array>
        }
        @case ('optionalDate') {
          <optional-date
            [direction]="direction"
            [config]="config"
            [group]="form"
          >
          </optional-date>
        }
        @case ('conditionalToggle') {
          <conditional-toggle
            [formControlName]="config.prop"
            [parentForm]="form"
            [config]="config"
          >
          </conditional-toggle>
        }
        @default {
          <custom-form-element
            (formCreated)="handleFormCreated($event, config)"
            [direction]="direction"
            [config]="config"
            [form]="form"
            [prefillVal]="prefillVal"
          >
          </custom-form-element>
        }
      }
    </div>
  </ng-template>
}
